import ChannelLayout from './ChannelLayout'

export default ChannelLayout
